import PropTypes from 'prop-types';
import React from 'react';
import { StepsProvider } from 'react-step-builder';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';
import '@fontsource/playfair-display/700.css';

import Header from '~/components/layout/header';
import Footer from '~/components/layout/footer';
import SkipLink from '~/components/modules/navigation/skip-link';
import Jumbotron from '~/components/modules/jumbotron';
import NavPage from '~/components/modules/navigation/page';

const Layout = ({
	location,
	children,
	pageAnchors,
	sectionTitle,
	sectionUrl,
	hasJumbotron = true,
	hasNavigation,
	jumbotron,
	jumbotronTitle,
	jumbotronSubtitle,
	jumbotronDescription,
	jumbotronImage,
	jumbotronImageAlt,
	showToolkitsLabel,
	navbar,
	...jumbotronProps
}) => {
	return (
		<StepsProvider>
			<div id="top" className="relative">
				<SkipLink />
				<Header
					location={location}
					hasNavigation={hasNavigation}
					sectionTitle={sectionTitle}
					sectionUrl={sectionUrl}
					showToolkitsLabel={showToolkitsLabel}
					navbar={navbar}
				/>

				<main id="start-of-content">
					{jumbotron ?
						jumbotron
						:
						hasJumbotron &&
							<Jumbotron
								subtitle={jumbotronSubtitle}
								title={jumbotronTitle}
								description={jumbotronDescription}
								image={jumbotronImage}
								imageAlt={jumbotronImageAlt}
								{...jumbotronProps}
							/>
					}

					{pageAnchors &&
						<NavPage
							anchors={pageAnchors}
						/>
					}

					{children}
				</main>

				<Footer />
			</div>
		</StepsProvider>
	);
};

Layout.propTypes = {
	children: PropTypes.node.isRequired
};

export default Layout;
